exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.search {\n  position: absolute;\n  top: 60px;\n  left: 0;\n  width: 100vw;\n  height: 80px;\n  z-index: 10000;\n  background-color: #F1F4F8;\n  box-sizing: border-box;\n  padding: 0 30px;\n  display: flex;\n  align-items: center;\n}\n\ndiv.search input[type='text'], \ndiv.search button,\ndiv.search > span {\n  height: 40px;\n  padding: 0 15px;\n}\n\ndiv.search > span {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: 0px;\n  background-color: white;\n  font-size: 1.2em;\n}\n\ndiv.search input[type='text'] {\n  padding-left: 5px;\n  width: 160px;\n  box-sizing: border-box;\n}\n\n.search-go {\n  color: white;\n  background-color: rgb(82, 210, 155);\n}\n\ndiv.search div.slider-group {\n  width: 900px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  box-sizing: border-box;\n  padding: 0 50px;\n}\n\n.spinner-searchbar {\n  border: 5px solid #f3f3f3;\n  border-top: 5px solid #3498db;\n  width: 30px;\n  height: 30px;\n  margin-left: 5px;\n}\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/Search/main.css
// module id = 774
// module chunks = 0